import {
    can_mortgage_payment_purchase as calculateNewMortgagePayment,
    can_mortgage_payment as calculateExistingMortgagePayment,
} from '@ratehub/mortgage-calculations';
import { PAYMENT_FREQUENCIES } from '@ratehub/documents/mtg-journey-document/stable';

import SCENARIO_TYPES from '../definitions/scenarioTypes';
import getPaymentFrequencyAndDivisor from './getPaymentFrequencyAndDivisor';
import { getMinimumDownPaymentPercent } from './getMinimumDownPayment';


function getMonthlyPaymentForScenario(
    rateValue,
    {
        scenario,
        homePrice,
        downPaymentPercent,
        downPaymentDollars,
        amortization = 25,
        currentMortgageBalance,
        paymentFrequency = PAYMENT_FREQUENCIES.MONTHLY,
        additionalFunds = 0,
        helocAmount,
    },
) {
    if (!rateValue || !Object.values(SCENARIO_TYPES).includes(scenario)) {
        throw new Error('Unable to calculate montly payment without rateValue or scenario');
    }

    const { frequency, divisor } = getPaymentFrequencyAndDivisor(paymentFrequency);
    const percentage = getDownPaymentPercent(homePrice, downPaymentPercent, downPaymentDollars);

    switch (scenario) {
        case SCENARIO_TYPES.PURCHASE:
        case SCENARIO_TYPES.PRE_APPROVAL:
            return calculateNewMortgagePayment(
                homePrice,
                percentage,
                rateValue / 100,
                amortization,
                frequency,
                divisor,
            );
        case SCENARIO_TYPES.RENEWAL:
            return calculateExistingMortgagePayment(
                currentMortgageBalance,
                rateValue / 100,
                amortization,
                frequency,
                divisor,
            );
        case SCENARIO_TYPES.REFINANCE:
            return calculateExistingMortgagePayment(
                currentMortgageBalance + additionalFunds, // Total mortgage needed
                rateValue / 100,
                amortization,
                frequency,
                divisor,
            );
        case SCENARIO_TYPES.HELOC:
            return (rateValue / 100 / frequency) * helocAmount;
    }
}

function getDownPaymentPercent(homePrice, percent, dollars) {
    if (typeof percent === 'number') {
        // If percent is already a decimal, leave it as is otherwise update it
        return percent < 1 ? percent : percent / 100;
    }

    if (typeof dollars === 'number' && homePrice > 0) {
        return dollars / homePrice;
    }

    return getMinimumDownPaymentPercent(homePrice);
}

export default getMonthlyPaymentForScenario;